/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Prereq_Job_LinkInputs */

const en_cover_letters_prereq_job_link = /** @type {(inputs: Cover_Letters_Prereq_Job_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Jobs`)
};

const de_cover_letters_prereq_job_link = /** @type {(inputs: Cover_Letters_Prereq_Job_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu den Jobs`)
};

const fr_cover_letters_prereq_job_link = /** @type {(inputs: Cover_Letters_Prereq_Job_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller aux emplois`)
};

const es_cover_letters_prereq_job_link = /** @type {(inputs: Cover_Letters_Prereq_Job_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a empleos`)
};

const it_cover_letters_prereq_job_link = /** @type {(inputs: Cover_Letters_Prereq_Job_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai ai lavori`)
};

const nl_cover_letters_prereq_job_link = /** @type {(inputs: Cover_Letters_Prereq_Job_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar banen`)
};

const pl_cover_letters_prereq_job_link = /** @type {(inputs: Cover_Letters_Prereq_Job_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdz do ofert pracy`)
};

const fi_cover_letters_prereq_job_link = /** @type {(inputs: Cover_Letters_Prereq_Job_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siirry työpaikkoihin`)
};

const da_cover_letters_prereq_job_link = /** @type {(inputs: Cover_Letters_Prereq_Job_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga til job`)
};

const sv_cover_letters_prereq_job_link = /** @type {(inputs: Cover_Letters_Prereq_Job_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga till jobb`)
};

/**
* | output |
* | --- |
* | "Go to Jobs" |
*
* @param {Cover_Letters_Prereq_Job_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_prereq_job_link = /** @type {((inputs?: Cover_Letters_Prereq_Job_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Prereq_Job_LinkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_prereq_job_link(inputs)
	if (locale === "fr") return fr_cover_letters_prereq_job_link(inputs)
	if (locale === "es") return es_cover_letters_prereq_job_link(inputs)
	if (locale === "it") return it_cover_letters_prereq_job_link(inputs)
	if (locale === "nl") return nl_cover_letters_prereq_job_link(inputs)
	if (locale === "pl") return pl_cover_letters_prereq_job_link(inputs)
	if (locale === "fi") return fi_cover_letters_prereq_job_link(inputs)
	if (locale === "da") return da_cover_letters_prereq_job_link(inputs)
	if (locale === "sv") return sv_cover_letters_prereq_job_link(inputs)
	return en_cover_letters_prereq_job_link(inputs)
});